var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.langShow ? "button-select" : "button-selecten" },
    [
      _vm._t("header"),
      _c(
        "el-skeleton",
        { attrs: { loading: _vm.data.length == 0, animated: "", rows: 7 } },
        [
          _vm._l(_vm.data, function (item) {
            return [
              item.children.length > 0
                ? _c("div", { key: item.value, staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (_vm.multipleCompany && item.value != 0) ||
                              !_vm.multipleCompany,
                            expression:
                              "(multipleCompany && item.value!=0) || !multipleCompany",
                          },
                        ],
                        staticClass: "row-title",
                      },
                      [
                        _c("el-checkbox", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.multipleCompany,
                              expression: "multipleCompany",
                            },
                          ],
                          attrs: { indeterminate: item.isIndeterminate },
                          on: {
                            change: (val) =>
                              _vm.handleCheckAllChange(val, item),
                          },
                          model: {
                            value: item.checked,
                            callback: function ($$v) {
                              _vm.$set(item, "checked", $$v)
                            },
                            expression: "item.checked",
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(item.label))]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.multipleCompany && item.value == 0,
                            expression: "multipleCompany && item.value==0",
                          },
                        ],
                        staticClass: "row-title",
                      },
                      [
                        _c("el-checkbox", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.multipleCompany,
                              expression: "multipleCompany",
                            },
                          ],
                          attrs: { indeterminate: _vm.chooseAllIndeterminate },
                          on: {
                            change: (val) =>
                              _vm.handleCheckAllCountry(val, item),
                          },
                          model: {
                            value: _vm.chooseAllChecked,
                            callback: function ($$v) {
                              _vm.chooseAllChecked = $$v
                            },
                            expression: "chooseAllChecked",
                          },
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$i18.language("全选")))]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "selects" },
                      [
                        _vm._l(item.children, function (c) {
                          return [
                            (_vm.multipleCompany && c.value != 0) ||
                            !_vm.multipleCompany
                              ? [
                                  _vm.$url.countryPermission(c.value) &&
                                  ((c.label.length * 2 +
                                    String(c.count).length >
                                    17 &&
                                    c.flag) ||
                                    (!c.flag &&
                                      c.label.length * 2 +
                                        String(c.count).length >
                                        21))
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          key: c.value,
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: c.label,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "select-item",
                                              class: _vm.single
                                                ? _vm.value === c.value
                                                  ? "active"
                                                  : ""
                                                : _vm.value.indexOf(c.value) >
                                                  -1
                                                ? "active"
                                                : "",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.changeSelect(
                                                    c,
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "name-left" },
                                                [
                                                  c.flag
                                                    ? _c("div", {
                                                        class: [
                                                          c.isOpen == false ||
                                                          (_vm.multipleCompany &&
                                                            c.value == 0)
                                                            ? " backcolor"
                                                            : "backcolor3",
                                                          "all-country-map-img",
                                                        ],
                                                        style: {
                                                          backgroundPosition:
                                                            c.value == 0
                                                              ? `-384px  -166px`
                                                              : `${
                                                                  c.x * -1
                                                                }px  ${
                                                                  c.y * -1
                                                                }px`,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    { staticClass: "name" },
                                                    [_vm._v(_vm._s(c.label))]
                                                  ),
                                                  c.isNew == true
                                                    ? _c("svg-icon", {
                                                        staticClass: "newIcon",
                                                        attrs: {
                                                          name: "new-tobottom",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              c.count !== undefined &&
                                              c.count !== 0
                                                ? _c(
                                                    "div",
                                                    { staticClass: "count" },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(c.count) +
                                                          ")"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : [
                                        _vm.$url.countryPermission(c.value)
                                          ? _c(
                                              "div",
                                              {
                                                key: c.value,
                                                staticClass: "select-item",
                                                class: [
                                                  _vm.single
                                                    ? _vm.value === c.value
                                                      ? "active"
                                                      : ""
                                                    : _vm.value.indexOf(
                                                        c.value
                                                      ) > -1
                                                    ? "active"
                                                    : "",
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.changeSelect(
                                                      c,
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "name-left" },
                                                  [
                                                    c.flag
                                                      ? _c("div", {
                                                          class: [
                                                            c.isOpen == false ||
                                                            (_vm.multipleCompany &&
                                                              c.value == 0)
                                                              ? " backcolor"
                                                              : "backcolor3",
                                                            "all-country-map-img",
                                                          ],
                                                          style: {
                                                            backgroundPosition:
                                                              c.value == 0
                                                                ? `-384px  -166px`
                                                                : `${
                                                                    c.x * -1
                                                                  }px  ${
                                                                    c.y * -1
                                                                  }px`,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _c(
                                                      "div",
                                                      { staticClass: "name" },
                                                      [_vm._v(_vm._s(c.label))]
                                                    ),
                                                    c.isNew == true
                                                      ? _c("svg-icon", {
                                                          staticClass:
                                                            "newIcon",
                                                          attrs: {
                                                            name: "new-tobottom",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                c.count !== undefined &&
                                                c.count !== 0
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "count" },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              c.count
                                                                ? c.count
                                                                : 0
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                ]
                              : _vm._e(),
                          ]
                        }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }